import React, { useMemo } from "react";

const COLORS = ["#c9a84c", "#d9bd72", "#3d9e8f", "#56b0a2", "#ede2c4", "#2a6f64"];

function Confetti() {
  const pieces = useMemo(
    () =>
      Array.from({ length: 28 }).map((_, i) => ({
        id: `confetti-${i}`,
        left: Math.random() * 100,
        bg: COLORS[i % COLORS.length],
        delay: Math.random() * 0.6,
        dur: 2.4 + Math.random() * 1.8,
        rot: Math.random() * 360,
      })),
    []
  );
  return (
    <div className="confetti" aria-hidden="true">
      {pieces.map((p) => (
        <i
          key={p.id}
          style={{
            left: `${p.left}%`,
            background: p.bg,
            transform: `rotate(${p.rot}deg)`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.dur}s`,
          }}
        />
      ))}
    </div>
  );
}

export default function Day30Celebration({ stats, vault, onClose }) {
  return (
    <div className="day30-overlay" role="dialog" aria-modal="true" aria-labelledby="day30-title" data-testid="day30-modal">
      <div className="day30-modal">
        <Confetti />
        <button className="day30-close" onClick={onClose} aria-label="Close celebration" data-testid="day30-close">×</button>
        <div className="day30-head">
          <span className="day30-badge">Findability Cycle Complete</span>
          <h2 className="day30-title" id="day30-title">You showed up.<br /><em>Your story is ready to be found.</em></h2>
        </div>
        <div className="day30-body">
          <p className="day30-msg">
            You completed 30 focused efforts — and in doing them, you created clearer, more consistent
            searchable work that helps the right people find you. You didn't just learn AEO. You did it.
            That momentum is the most valuable thing you have right now.
          </p>
          <div className="day30-stats">
            <div className="day30-stat"><span>Efforts Complete</span><strong data-testid="day30-stat-days">{stats.n}</strong></div>
            <div className="day30-stat"><span>Posts Saved</span><strong data-testid="day30-stat-posts">{vault.length}</strong></div>
            <div className="day30-stat"><span>Findability</span><strong data-testid="day30-stat-score">{stats.score}</strong></div>
          </div>

          <div className="day30-cta-card">
            <div className="day30-cta-eyebrow">Your next chapter</div>
            <div className="day30-cta-title">Keep the momentum going</div>
            <div className="day30-cta-desc">
              Finishing your Cycle isn't the finish line — it's the moment your visibility starts compounding. Join Oracle Connections
              to keep showing up with monthly workshops, live support, and a community doing this work alongside you.
            </div>
            <a
              className="day30-cta-btn"
              href="https://joannelangston.com"
              target="_blank"
              rel="noreferrer"
              data-testid="day30-cta-button"
            >
              Explore what's next at joannelangston.com →
            </a>
          </div>

          <button className="day30-dismiss" onClick={onClose} data-testid="day30-dismiss">
            I'll keep going on my own for now
          </button>
        </div>
      </div>
    </div>
  );
}
